import { castArray } from 'lodash-es';

import { services } from 'services/base';
import { getModulesConfig, isAppModule, isAvailable, isMobileNavigationModule } from 'utils';

const SERVICE_PREFIX = 'appFrame.mobileNavigation';
const ACTION_CHANGE_OPEN = 'AppFrame:MobileNavigation:onOpenChange';
const ACTION_CHANGE_MOBILE_NAVIGATION = 'AppFrame:MobileNavigation:onMobileNavigationChange';

const hasMobileNavigation = () => {
  return (
    services.appFrame.mobileNavigation.applications.getItems().length > 1 &&
    services.appFrame.mobileNavigation.others.getItems().length > 0 &&
    services.appFrame.preferences
      .getItems()
      .filter((item) => isAvailable(item.available ?? true))
      .filter(isMobileNavigationModule).length > 0
  );
};

const getDefaultApplications = () =>
  castArray(getModulesConfig() || [])
    .filter((item) => isAvailable(item.available))
    .filter(isAppModule)
    .filter(isMobileNavigationModule);

const updateMobileNavigation = () => services.executeAction(ACTION_CHANGE_MOBILE_NAVIGATION, hasMobileNavigation());

const initMobileNavigationServices = () => {
  const { executeAction, registerAction, registerService, clearAction, registerCollection } = services;

  const state = {
    open: false,
    mobileNavigation: false,
  };

  // open / close / toggle services
  registerAction<boolean>(
    ACTION_CHANGE_OPEN,
    (open) => {
      state.open = open;
    },
    { order: 0 },
  );
  registerService(`${SERVICE_PREFIX}.open`, () => {
    if (state.open) {
      return;
    }
    executeAction(ACTION_CHANGE_OPEN, true);
  });
  registerService(`${SERVICE_PREFIX}.close`, () => {
    if (!state.open) {
      return;
    }
    executeAction(ACTION_CHANGE_OPEN, false);
  });
  registerService(`${SERVICE_PREFIX}.toggle`, () => {
    executeAction(ACTION_CHANGE_OPEN, !state.open);
  });
  registerService(`${SERVICE_PREFIX}.isOpen`, () => state.open);
  registerService(`${SERVICE_PREFIX}.onOpenChange`, (callbackFn) => {
    registerAction(ACTION_CHANGE_OPEN, callbackFn, { order: 1 });
    return () => clearAction(ACTION_CHANGE_OPEN, callbackFn);
  });

  // applications collection services
  registerCollection(`${SERVICE_PREFIX}.applications`, getDefaultApplications());
  services.appFrame.sidebar.onItemChange((/* reason: CollectionItemChangeReason */) => {
    services.appFrame.mobileNavigation.applications.setDefaultItems(getDefaultApplications());
  });

  registerCollection(`${SERVICE_PREFIX}.others`);

  //  mobile navigation availability
  registerAction<boolean>(
    ACTION_CHANGE_MOBILE_NAVIGATION,
    (available) => {
      state.mobileNavigation = available;
    },
    { order: 0 },
  );
  services.appFrame.mobileNavigation.others.onItemChange(updateMobileNavigation);
  services.appFrame.mobileNavigation.applications.onItemChange(updateMobileNavigation);
  services.appFrame.preferences.onItemChange(updateMobileNavigation);
  registerService(`${SERVICE_PREFIX}.hasMobileNavigation`, () => state.mobileNavigation);
  registerService(`${SERVICE_PREFIX}.onMobileNavigationChange`, (callbackFn) => {
    registerAction(ACTION_CHANGE_MOBILE_NAVIGATION, callbackFn, { order: 1 });
    return () => clearAction(ACTION_CHANGE_MOBILE_NAVIGATION, callbackFn);
  });

  updateMobileNavigation();
};

export default initMobileNavigationServices;
